import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id B34E6142-64AF-43FE-A565-2FAEEA35B800
 * name arrow-bottom-left-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-left-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomLeftBoldOutlineIcon = createSvgIcon(<><path d="M18.36,19.78H4.22V5.64L8.47,9.88L14.12,4.22L19.78,9.88L14.12,15.54L18.36,19.78M6.34,17.66H13.41L11.29,15.54L16.95,9.88L14.12,7.05L8.46,12.71L6.34,10.59V17.66Z" /></>, 'ArrowBottomLeftBoldOutlineIcon');
export default ArrowBottomLeftBoldOutlineIcon